import { render } from "./yzm.vue?vue&type=template&id=6b28158f"
import script from "./yzm.vue?vue&type=script&lang=js"
export * from "./yzm.vue?vue&type=script&lang=js"

import "./yzm.vue?vue&type=style&index=0&id=6b28158f&lang=css"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__